import {initItemcardImages} from "./itemcardImages";
import {triggerCopyLink} from "../../../default/global/js/copyToClipboard";
import {itemcardSubscriptions} from "../../../default/global/js/subscriptions";
import {shareItemcardModal} from "../../../default/global/js/shareItemcard";
import {initVariantSelection} from "../../../bataillard-global/js/variantSelection";
import {initItemcardNavigation} from "../../../bataillard-global/js/itemcardNavigation";
import {initVariantsButtonsSelection} from "../../../bataillard-global/js/variantSelectionButton";

window.addEventListener("load", (event) => {
    initItemcardImages();
    triggerCopyLink();
    itemcardSubscriptions();
    shareItemcardModal();
    initVariantSelection();
    initVariantsButtonsSelection();
    initItemcardNavigation();
});